export default __webpack_public_path__ + "media/images/lp/hero_pc-e011362aeaaf989d9dd18b4922cf7f12.png";